import { Redirect } from 'expo-router'
import type { ReactNode } from 'react'

import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'

import { useIntentionsPrayFlow } from '../../hooks/useIntentionsPrayFlow'
import { IntentionsPrayFlowBase } from './IntentionsPrayFlowBase'

export const IntentionsPrayFlow = (): ReactNode => {
  const { routes } = useRoutes()
  const { handleBackPress } = useBackHandlePress(routes.watchmanIntentions())

  const { intentions, isLoading, next, pray, screenIndex, step, toIntentionPrayerIds } = useIntentionsPrayFlow()

  const hasIntentions = !!intentions?.length

  if (!isLoading && hasIntentions && step > intentions.length) {
    return <Redirect href={routes.watchmanIntentionsReward()} />
  }

  if (!isLoading && !hasIntentions) return <Redirect href={routes.intentions()} />

  const handleConfirmClose = () => handleBackPress()

  return (
    <IntentionsPrayFlowBase
      intentions={intentions}
      isLoading={isLoading}
      next={next}
      pray={pray}
      screenIndex={screenIndex}
      step={step}
      toIntentionPrayerIds={toIntentionPrayerIds}
      onConfirmClose={handleConfirmClose}
    />
  )
}
